module.exports = __webpack_public_path__ + "static/logo-9e41535a62c86db8a888ae1fd5fc6bb5.png";